<template>
  <teleport v-if="hasMounted" to="#portal-target">
    <div class="shortcut-overlay">
      <div class="shortcut-overlay__backdrop" @mousedown="emit('close')" />
      <div class="shortcut-overlay__panel">
        <slot />
      </div>
    </div>
  </teleport>
</template>

<script setup lang="ts">
import { useMounted } from '@lib/use-mounted';

const emit = defineEmits<{ close: [] }>();

const hasMounted = useMounted();
</script>

<style scoped lang="scss">
@import '@styles/variables';

.shortcut-overlay {
  position: fixed;
  inset: 0;
  z-index: $zi-overlay;

  &__backdrop {
    position: absolute;
    inset: 0;
    background: rgba($c-ink, 0.18);
    backdrop-filter: blur(2px);
  }

  &__panel {
    position: absolute;
    top: 12vh;
    left: 50%;
    transform: translateX(-50%);
    width: 60rem;
    max-width: calc(100vw - 4rem);
    max-height: 68vh;
    display: flex;
    flex-direction: column;
    border: 1px solid $c-hairline;
    border-radius: 1.6rem;
    background: $c-surface;
    // Two stacked shadows — a tight one that seats the panel and a wide, very soft
    // one that lifts it — rather than one heavy drop shadow.
    box-shadow:
      0 0.2rem 0.8rem rgba($c-ink, 0.06),
      0 2.4rem 6rem rgba($c-ink, 0.18);
    overflow: hidden;
    animation: shortcut-overlay-in 140ms cubic-bezier(0.16, 1, 0.3, 1);
  }
}

@keyframes shortcut-overlay-in {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(-0.8rem) scale(0.98);
  }
}

@media (prefers-reduced-motion: reduce) {
  .shortcut-overlay__panel {
    animation: none;
  }
}
</style>
